var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrekrlogo12(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 160.952,
    height: 69,
    viewBox: "0 0 160.952 69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.155,
    x2: 0.5,
    y2: 1.019,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5fccf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0054d9"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_679",
    x: 0,
    y: 0,
    width: 69,
    height: 69,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: -0.137,
    y2: 1.135,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2021",
    "data-name": "Group 2021",
    transform: "translate(-346 -140)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2013",
    "data-name": "Group 2013"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 346, 140)",
    filter: "url(#Ellipse_679)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_679-2",
    "data-name": "Ellipse 679",
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    transform: "translate(9 6)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2009",
    "data-name": "Group 2009",
    transform: "translate(27.193 90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10499",
    "data-name": "Path 10499",
    d: "M0,0,.469,2.467V8.435H0Z",
    transform: "translate(348.024 66)",
    fill: "#0556b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_9",
    "data-name": "Union 9",
    d: "M.469,10.083l.354-.589V3.954l-.447.267L0,3.6,5.986,0,5.979.877l-4.688,2.8V9.722l4.687,2.769-.006.9Z",
    transform: "translate(347.202 75.242)",
    fill: "#0556b4",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10511",
    "data-name": "Path 10511",
    d: "M.053,6.906.76,4.935.783,0H0Z",
    transform: "translate(357.162 90.948) rotate(-59)",
    fill: "#075ab8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_8",
    "data-name": "Union 8",
    d: "M0,12.468,4.692,9.74V3.656L.006.879V0L6.025,3.6l-.375.625-.488-.289V9.467l.02-.012.375.624L.006,13.366Z",
    transform: "translate(354.11 75.24)",
    fill: "#095bb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_7",
    "data-name": "Union 7",
    d: "M0,23.032V17.807l5.154-3.083v-6.7L0,4.883V0L9.373,5.619l0,0h0V16.869H9.3l-5.87,3.516,5.581,3.385L6.893,27.178Z",
    transform: "translate(354.116 70.686)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_6",
    "data-name": "Union 6",
    d: "M.017,21.555H0V0H4.217V7.711L9.372,4.686V9.508L4.217,12.589v6.842l5.155,3.062v4.65Z",
    transform: "translate(343.807 66)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "trekr.com.au",
    d: "M11.4-4.029a11.945,11.945,0,0,0,3.469-.632v4.1A12.368,12.368,0,0,1,9.81.361Q6.5.361,5-1.31A7.274,7.274,0,0,1,3.487-6.323v-9.738H.849v-2.331l3.035-1.843L5.474-24.5H9v4.3h5.655v4.137H9v9.738a2.151,2.151,0,0,0,.659,1.734A2.6,2.6,0,0,0,11.4-4.029ZM30.225-20.578a8.886,8.886,0,0,1,1.861.163l-.416,5.167a6.312,6.312,0,0,0-1.626-.181,5.843,5.843,0,0,0-4.11,1.355,4.9,4.9,0,0,0-1.472,3.794V0h-5.51V-20.2h4.173l.813,3.4h.271a7.593,7.593,0,0,1,2.538-2.737A6.259,6.259,0,0,1,30.225-20.578Zm13.152,3.92a3.5,3.5,0,0,0-2.746,1.111,5.142,5.142,0,0,0-1.138,3.153h7.732a4.593,4.593,0,0,0-1.066-3.153A3.609,3.609,0,0,0,43.377-16.657ZM44.154.361A10.425,10.425,0,0,1,36.53-2.331q-2.746-2.692-2.746-7.624,0-5.077,2.538-7.85a9.038,9.038,0,0,1,7.019-2.773,8.9,8.9,0,0,1,6.667,2.439A9.227,9.227,0,0,1,52.393-11.4v2.674H39.367a5.3,5.3,0,0,0,1.391,3.667A4.895,4.895,0,0,0,44.407-3.74a15.15,15.15,0,0,0,3.451-.379,17.266,17.266,0,0,0,3.4-1.21v4.264A12.939,12.939,0,0,1,48.165.009,19.478,19.478,0,0,1,44.154.361ZM62.167-10.984l2.4-3.071L70.224-20.2h6.215l-8.021,8.762L76.927,0H70.567L64.75-8.184l-2.367,1.9V0h-5.51V-28.111h5.51v12.538l-.289,4.589Zm28.924-9.593a8.886,8.886,0,0,1,1.861.163l-.416,5.167a6.312,6.312,0,0,0-1.626-.181,5.843,5.843,0,0,0-4.11,1.355,4.9,4.9,0,0,0-1.472,3.794V0h-5.51V-20.2h4.173l.813,3.4h.271a7.593,7.593,0,0,1,2.538-2.737A6.259,6.259,0,0,1,91.091-20.578Z",
    transform: "translate(414 186)",
    fill: "url(#linear-gradient-2)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrekrlogo12);
export default __webpack_public_path__ + "static/media/trekrlogo12.fc95a00f5b9da2ccb3c788cc818a57d8.svg";
export { ForwardRef as ReactComponent };